import React from 'react';
import TimelineSlideVideo from './TimelineSlideVideo';
import TimelineSlideImage from './TimelineSlideImage';
import { isLeftAligned, isRightAligned } from '../../utils/variations';
const TimelineSlideContainer = ({ fields, years, contentWidth, index }) => {
    if (!fields) {
        return null;
    }
    const alignment = fields.contentAlignment.value;
    if (isLeftAligned(alignment) || isRightAligned(alignment)) {
        return React.createElement(TimelineSlideImage, { fields: fields, years: years, contentWidth: contentWidth, index: index });
    }
    else {
        return React.createElement(TimelineSlideVideo, { fields: fields, years: years, contentWidth: contentWidth });
    }
};
export default TimelineSlideContainer;
